import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGithub, FaLinkedin, FaHeart } from 'react-icons/fa';

const Footer = ({ darkMode }) => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className={`py-6 ${darkMode ? 'bg-gray-900 text-gray-300' : 'bg-gray-100 text-gray-700'}`}>
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <p className="text-sm">
                            &copy; {currentYear} Starlin Frías. {t('footer.rights')}
                        </p>
                    </div>

                    <div className="flex items-center">
                        <p className="text-sm mr-2">
                            {t('footer.madeWith')} <FaHeart className="inline text-red-500" /> React
                        </p>
                    </div>

                    <div className="flex space-x-4 mt-4 md:mt-0">
                        <a
                            href="https://github.com/FriasLuna0102/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`text-xl hover:scale-110 transition-transform ${
                                darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'
                            }`}
                            aria-label="GitHub"
                        >
                            <FaGithub />
                        </a>
                        <a
                            href="https://www.linkedin.com/in/starlin-jose-frías-luna-03190628b/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`text-xl hover:scale-110 transition-transform ${
                                darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'
                            }`}
                            aria-label="LinkedIn"
                        >
                            <FaLinkedin />
                        </a>
                        {/*<a*/}
                        {/*    href="https://twitter.com/tuusuario"*/}
                        {/*    target="_blank"*/}
                        {/*    rel="noopener noreferrer"*/}
                        {/*    className={`text-xl hover:scale-110 transition-transform ${*/}
                        {/*        darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'*/}
                        {/*    }`}*/}
                        {/*    aria-label="Twitter"*/}
                        {/*>*/}
                        {/*    <FaTwitter />*/}
                        {/*</a>*/}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;